module.exports = __webpack_public_path__ + "img/visit-outpatient.266487fd.svg";